import { createContext } from "react";

const FetchMarksContext = createContext({});

export default FetchMarksContext;
